// utils/config.js
export const backendUrl = process.env.REACT_APP_API_URL
export const api_subscription_key = process.env.REACT_APP_API_SUBSCRIPTION_KEY;
export const landingUrl = process.env.REACT_APP_LANDING_URL || 'https://www.lawis.ai';